<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="MedicosForm"
      @pesquisar="pesquisar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
            <CampoNome @atualizar="filtro.nome = $event" />
          </div>
          <div class="form-group col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao @atualizar="filtro.ativo = $event" />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela><MedicoTabela :medicos="medicos" /></template>
      <template #fichas>
        <div
          v-for="m in medicos"
          :key="m._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <MedicoFicha :medico="m" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoNome from '@/componentes/formulario/CampoNome'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import MedicoServico from '@/servicos/MedicoServico'

import MedicoFicha from './MedicoFicha'
import MedicoTabela from './MedicoTabela'

export default {
  components: {
    MedicoFicha,
    MedicoTabela,
    BlocoFiltroPesquisa,
    CampoNome,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const servico = new MedicoServico()
    const nomeResultado = 'medicos'
    const medicos = ref([])
    const filtro = ref({
      nome: '',
      ativo: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: medicos,
      servico,
      nomeResultado,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(24)
    return { medicos, filtro, ...pesquisa }
  },
}
</script>
